import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import { Tooltip } from "@material-ui/core";
import { Card, CardBody, Col, Container, Row, Button } from "reactstrap";
import { isEmpty, sample } from "lodash";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
// import { Bar } from "react-chartjs-2";
import "assets/scss/table.scss";
import { getSchemeAnalytesList } from "store/results/actions";
import { getReport, getSereologyResult } from "store/resultsSubmit/actions";
import "assets/scss/table.scss";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Logo from "../../assets/images/LogoNeqas.jpg";
import autoTable from "jspdf-autotable";
class Results extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      SchemeAnalytesList: [],
      Report: [],
      SerologyResult: [],
      zScoresData: {}, // Store the fetched z-scores data
      combinedData: [], // Store the combined data here
      totalScore: "",
      possibleScore: "",
      accuracy: 0,
      // analyte: "",
      // rounds: [],
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",

      columnsList: [
        {
          text: "Analyte",
          dataField: "name",
          sort: true,
          headerClasses: "text-center",
          classes: "text-center",
          formatter: (cellContent, analyte) => (
            <div className="text-center">{analyte.name}</div>
          ),
        },
        {
          text: "Instrument",
          sort: true,
          headerClasses: "text-center",
          classes: "text-center",
          formatter: (cellContent, analyte) => {
            if (analyte.clot_matched)
              return <div className="text-center">-</div>;

            const isAbrogated =
              analyte.serology_status?.toLowerCase() === "abrogated";
            const isSubmitted =
              analyte.qualitative_result_type &&
              analyte.qualitative_result_type !== "Not Submitted";

            return (
              <div className="text-center">
                {isSubmitted && !isAbrogated ? analyte.instrument : "-"}
              </div>
            );
          },
        },
        {
          text: "No of Participants",
          headerClasses: "text-center",
          classes: "text-center",
          formatter: (cellContent, analyte) => {
            if (analyte.clot_matched)
              return <div className="text-center">-</div>;

            const isAbrogated =
              analyte.serology_status?.toLowerCase() === "abrogated";
            const isSubmitted =
              analyte.qualitative_result_type &&
              analyte.qualitative_result_type !== "Not Submitted";

            return (
              <div className="text-center">
                {isSubmitted && !isAbrogated ? analyte.lab_count : "-"}
              </div>
            );
          },
        },
        {
          text: "Your Result",
          headerClasses: "text-center",
          classes: "text-center",
          formatter: (cellContent, analyte) => {
            if (analyte.clot_matched) {
              return (
                <div
                  className="text-center"
                  style={{ color: "#e67e00", fontWeight: "600" }}
                >
                  Clot Matched
                </div>
              );
            }

            const isAbrogated =
              analyte.serology_status?.toLowerCase() === "abrogated";
            const isSubmitted =
              analyte.qualitative_result_type &&
              analyte.qualitative_result_type !== "Not Submitted";

            return (
              <div className="text-center">
                {!isSubmitted
                  ? "Not Submitted"
                  : isAbrogated
                  ? "-" // ✅ Submitted + Abrogated → "-"
                  : analyte.result_value}{" "}
               
              </div>
            );
          },
        },
        {
          text: "Expected Result",
          headerClasses: "text-center",
          classes: "text-center",
          formatter: (cellContent, analyte) => {
            if (analyte.clot_matched)
              return <div className="text-center">-</div>;

            const isAbrogated =
              analyte.serology_status?.toLowerCase() === "abrogated";
            const isSubmitted =
              analyte.qualitative_result_type &&
              analyte.qualitative_result_type !== "Not Submitted";

            return (
              <div className="text-center">
                {!isSubmitted ? (
                  "-"
                ) : isAbrogated ? (
                  <span style={{ color: "red", fontWeight: "600" }}>
                    Abrogated by EQA Provider
                  </span>
                ) : (
                  analyte.true_value || "N/A"
                )}
              </div>
            );
          },
        },
        {
          text: "Score",
          headerClasses: "text-center",
          classes: "text-center",
          formatter: (cellContent, analyte) => {
            if (analyte.clot_matched)
              return <div className="text-center">-</div>;

            const isAbrogated =
              analyte.serology_status?.toLowerCase() === "abrogated";
            const isSubmitted =
              analyte.qualitative_result_type &&
              analyte.qualitative_result_type !== "Not Submitted";

            return (
              <div className="text-center">
                {isSubmitted && !isAbrogated ? analyte.score : "-"}
              </div>
            );
          },
        },
      ],
    };
  }
  getBase64Image = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous"; // important for Webpack URLs
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/jpeg"); // Convert to Base64
        resolve(dataURL);
      };
      img.onerror = (error) => reject(error);
      img.src = url;
    });
  };
  combineData = (analytes, report, serologyResults) => {
    const analyteResultSummary =
      this.props.Report?.analyte_result_summary || [];
    const graphData = this.props.Report?.graph_data || [];

    let totalScore = 0;
    let possibleScore = 0;

    const combinedData = analytes.map((analyte) => {
      const resultEntry = report.find(
        (result) =>
          result?.analyte_id === analyte.id &&
          result?.account_id === this.state.user_id,
      );

      const summaryEntry = analyteResultSummary.find(
        (summary) => Number(summary.analyte_id) === Number(analyte.id),
      );

      const graphEntry = graphData.find(
        (g) => Number(g.analyte_id) === Number(analyte.id),
      );

      const qualitativeSubmitted =
        resultEntry?.qualitative_result_type &&
        resultEntry.qualitative_result_type !== "Not Submitted";

      const result_value = qualitativeSubmitted
        ? resultEntry.qualitative_result_type
        : "Not Submitted";

      const labCount = qualitativeSubmitted
        ? graphEntry?.lab_count ??
          summaryEntry?.lab_count ??
          resultEntry?.lab_count ??
          0
        : null;
      const serologyStatus = resultEntry?.serology_status;
      const isAbrogated = serologyStatus?.toLowerCase() === "abrogated";
      const expectedResult = qualitativeSubmitted
        ? resultEntry?.true_value ?? resultEntry?.expected_result ?? "N/A"
        : null;

      const score = qualitativeSubmitted ? resultEntry?.score || 0 : 0;

      // ✅ Only count submitted analytes toward possible score
      // ✅ Only count NON-abrogated + submitted analytes
      if (qualitativeSubmitted && !isAbrogated) {
        possibleScore += 5;
        totalScore += score;
      }

      return {
        ...analyte,
        lab_count: labCount,
        clot_matched: resultEntry?.clot_matched ?? false,
        instrument: resultEntry?.instrument || "",
        qualitative_result_type: resultEntry?.qualitative_result_type ?? null,
        result_value,
        score,
        true_value: expectedResult,
        serology_status: serologyStatus,
      };
    });
    const sortedData = combinedData.sort((a, b) =>
      a.name.localeCompare(b.name),
    );
    const accuracy = possibleScore ? (totalScore / possibleScore) * 100 : 0;

    return { combinedData, sortedData, totalScore, possibleScore, accuracy };
  };

  componentDidMount() {
    console.log("🔍 componentDidMount triggered");

    const { onGetSchemeAnalyte, onGetReport, onGetSereologyResult } =
      this.props;

    const id = this.props.match.params.id; // scheme id (if used)
    const roundId = this.props.match.params.id; // ✅ round id
    const labId = this.props.match.params.id1; // ✅ lab id (participant id)

    // 🧭 Log all important IDs
    console.log("🧩 Route Params:", this.props.match.params);
    console.log("📦 Scheme ID:", id);
    console.log("🎯 Round ID:", roundId);
    console.log("🏥 Participant (Lab) ID:", labId);

    // 🧠 Dispatch actions
    onGetSchemeAnalyte(id);
    onGetReport(roundId, labId);
    onGetSereologyResult(id);
  }

  componentDidUpdate(prevProps) {
    const { SchemeAnalytesList, Report, SerologyResult } = this.props;

    if (
      (SchemeAnalytesList !== prevProps.SchemeAnalytesList ||
        Report !== prevProps.Report ||
        SerologyResult !== prevProps.SerologyResult) &&
      !isEmpty(SchemeAnalytesList) &&
      !isEmpty(Report) &&
      !isEmpty(SerologyResult)
    ) {
      console.log("🔍 SchemeAnalytesList:", SchemeAnalytesList);
      console.log("📄 Report from API:", Report);
      console.log("🧪 SerologyResult:", SerologyResult);
      const { combinedData, totalScore, possibleScore, accuracy } =
        this.combineData(
          SchemeAnalytesList,
          Report.participants_results || [], // ✅ Use actual array
          SerologyResult,
        );

      if (
        JSON.stringify(combinedData) !== JSON.stringify(this.state.combinedData)
      ) {
        this.setState({ combinedData, totalScore, possibleScore, accuracy });
      }
    }
  }
  handleDownloadPDF = async () => {
    const { combinedData, totalScore, possibleScore, accuracy } = this.state;
    const { Report, rounds, sample, issue_date, closing_date } = this.props;

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();

    // Convert logo to Base64 first
    const base64Logo = await this.getBase64Image(Logo);
    const imgProps = pdf.getImageProperties(base64Logo);
    const imgWidth = 30;
    const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
    const centerX = (pageWidth - imgWidth) / 2;

    pdf.addImage(base64Logo, "JPEG", centerX, 10, imgWidth, imgHeight);

    // Header
    pdf.setFontSize(14);
    pdf.setTextColor("#0000FF");
    pdf.text(
      "NHS - National External Quality Assessment Scheme",
      pageWidth / 2,
      20 + imgHeight,
      { align: "center" },
    );

    // Participant / Scheme Info
    const infoStartY = 35 + imgHeight;
    const infoGap = 6;

    pdf.setFontSize(10);
    pdf.setTextColor("#000000");

    pdf.text(
      `Participant Name: ${Report?.participant_name || "--"}`,
      15,
      infoStartY,
    );
    pdf.text(
      `Issue Date: ${moment(issue_date).format("DD-MMM-YY")}`,
      15,
      infoStartY + infoGap,
    );
    pdf.text(
      `Closing Date: ${moment(closing_date).format("DD-MMM-YY")}`,
      15,
      infoStartY + infoGap * 2,
    );
    pdf.text(
      `Print Date: ${moment().format("DD-MMM-YY, HH:mm")}`,
      15,
      infoStartY + infoGap * 3,
    );

    pdf.text(`Scheme: ${Report?.scheme_name || "--"}`, 110, infoStartY);
    pdf.text(`Cycle: ${Report?.cycle_no || "--"}`, 110, infoStartY + infoGap);
    pdf.text(`Round: ${rounds || "--"}`, 110, infoStartY + infoGap * 2);
    pdf.text(`Sample: ${sample || "--"}`, 110, infoStartY + infoGap * 3);

    // ✅ SAME logic as frontend
    const hasSubmittedResults = combinedData.some(
      (a) =>
        a.qualitative_result_type &&
        a.qualitative_result_type !== "Not Submitted",
    );

    const showClotMatchedNotice =
      combinedData.length > 0 &&
      combinedData.every((a) => a.clot_matched) &&
      !hasSubmittedResults;

    const onlySampleConditionMsg = Report?.participants_results?.find(
      (r) => r.message,
    );

    // ✅ MESSAGE SPACING FIX (🔥 KEY CHANGE HERE)
    if (showClotMatchedNotice || onlySampleConditionMsg) {
      pdf.setFontSize(12);
      pdf.setTextColor("#6C48C5");

      const messageY = infoStartY + infoGap * 6; // ✅ Increased spacing

      pdf.text(
        onlySampleConditionMsg?.message ||
          "Pre-Analytic challenge detected Successfully",
        pageWidth / 2,
        messageY,
        { align: "center" },
      );

      pdf.save("Participant-results-report.pdf");
      return;
    }

    // Table
    const tableColumns = this.state.columnsList.map((col) => col.text);

    const tableRows = combinedData.map((analyte) => {
      const isAbrogated =
        analyte.serology_status?.toLowerCase() === "abrogated";
      const isSubmitted =
        analyte.qualitative_result_type &&
        analyte.qualitative_result_type !== "Not Submitted";

      if (analyte.clot_matched) {
        return [analyte.name, "-", "-", "Clot Matched", "-", "-"];
      }

      return [
        analyte.name,
        isSubmitted && !isAbrogated ? analyte.instrument || "-" : "-",
        isSubmitted && !isAbrogated ? analyte.lab_count : "-",
        // isSubmitted ? analyte.result_value : "Not Submitted", // ✅ No abrogated check here
        isSubmitted && !isAbrogated
          ? analyte.result_value
          : isSubmitted
          ? "-"
          : "Not Submitted",
        !isSubmitted
          ? "-"
          : isAbrogated
          ? "Abrogated by EQA Provider"
          : analyte.true_value || "N/A",
        isSubmitted && !isAbrogated ? analyte.score : "-",
      ];
    });

    autoTable(pdf, {
      head: [tableColumns],
      body: tableRows,
      startY: infoStartY + infoGap * 5,
      styles: { fontSize: 9, cellPadding: 2 },
      headStyles: { fillColor: [108, 72, 197], textColor: 255 },
      theme: "grid",
    });

    // Score summary
    let finalY = pdf.lastAutoTable.finalY + 8 || infoStartY + infoGap * 5 + 8;

    pdf.setFontSize(10);
    pdf.setTextColor("#6C48C5");

    pdf.text(
      `You have submitted results for ${
        combinedData.filter(
          (a) =>
            a.qualitative_result_type &&
            a.qualitative_result_type !== "Not Submitted",
        ).length
      } analytes out of total ${combinedData.length} analytes.`,
      15,
      finalY,
    );

    finalY += 6;
    pdf.text(
      `Your TOTAL SCORE is ${totalScore} out of a possible score of ${possibleScore}`,
      15,
      finalY,
    );

    finalY += 6;
    pdf.text(`Your accuracy is ${accuracy.toFixed(2)}%`, 15, finalY);

    pdf.save("Participant-results-report.pdf");
  };

  render() {
    const { rounds, issue_date, closing_date, Report } = this.props;
    const { combinedData, totalScore, possibleScore, accuracy } = this.state;
    // Count total analytes and submitted results
    const totalAnalytes = combinedData.length; // Total number of analytes
    const submittedResultsCount = combinedData.filter(
      (analyte) =>
        analyte.qualitative_result_type &&
        analyte.qualitative_result_type !== "Not Submitted",
    ).length;

    const participant_id = this.props.match.params.id1;
    const defaultSorted = [
      {
        dataField: "analyte_name",
        order: "asc",
      },
    ];
    const hasSubmittedResults = combinedData.some(
      (a) =>
        a.qualitative_result_type &&
        a.qualitative_result_type !== "Not Submitted",
    );

    // Show "Pre-Analytic challenge" only if all analytes are clot matched AND nothing is submitted
    const showClotMatchedNotice =
      combinedData.length > 0 &&
      combinedData.every((a) => a.clot_matched) &&
      !hasSubmittedResults;
    return (
      <React.Fragment>
        <Container
          id="report-area" // ✅ added
          fluid
          style={{
            paddingTop: "10%",
            paddingBottom: "10%",
            paddingLeft: "10%",
            paddingRight: "10%",
          }}
        >
          <div className="d-flex justify-content-end mb-3">
            <Button
              className="w-25 no-print btn btn-outline-secondary"
              onClick={this.handleDownloadPDF}
            >
              Download
            </Button>
          </div>

          <style>
            {`@media print {
              .no-print { display: none !important; }
              /* General print settings */
              body {
                font-size: 12px;
                line-height: 1.4;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }

              /* Hide unwanted elements */
              .navbar, .footer, .breadcrumb {
                display: none !important;
              }

              /* First page margins */
              @page :first {
                size: A4;
                margin: 20mm 20mm 20mm 20mm; /* top, right, bottom, left */
              }

              /* Margins for subsequent pages */
              @page {
                size: A4;
                margin: 80mm 20mm 20mm 20mm; /* bigger top margin for subsequent pages */
              }
              /* Optional: Table styling for print */
              table {
                width: 100% !important;
                border: 1px solid #dee2e6;
                border-collapse: collapse;
              }

              th, td {
                padding: 8px;
                text-align: left;
              }

              /* Report header */
              .report-header {
                display: block !important;
              }

              .report-header h4, .report-header h6 {
                font-size: 12px;
              }
              .print-content {
                display: block;
                page-break-inside: auto;
                padding-top: 10mm; /* adds space for subsequent pages */
              }
            }

            .table thead th {
              background-color: #6C48C5;
              // background-color: #C68FE6;
              color: white; /* White text for contrast */
            }
            .table td {
              text-align: left !important; /* Use this if necessary */
            }
              

            `}
          </style>

          {/* Report Header */}
          <div className="report-header my-4">
            <div className="text-center mb-3">
              <img
                src={Logo}
                alt="Logo"
                style={{ height: "60px", marginBottom: "10px" }}
              />

              <h4 style={{ fontWeight: "bold", color: "blue" }}>
                NHS - National External Quality Assessment Scheme
              </h4>
            </div>
            <Row>
              <Row>
                {/* Left Column */}
                <Col md={6}>
                  <Row className="mb-2">
                    <Col
                      xs={6}
                      className="text-end"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Participant Name:
                    </Col>
                    <Col xs={6} className="text-left" style={{ color: "blue" }}>
                      {this.props.Report?.participant_name || "No name found"}
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col
                      xs={6}
                      className="text-end"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Issue Date:
                    </Col>
                    <Col xs={6} className="text-left" style={{ color: "blue" }}>
                      {moment(issue_date).format("DD-MMM-YY")}
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col
                      xs={6}
                      className="text-end"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Closing Date:
                    </Col>
                    <Col xs={6} className="text-left" style={{ color: "blue" }}>
                      {moment(closing_date).format("DD-MMM-YY")}
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col
                      xs={6}
                      className="text-end"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Print Date:
                    </Col>
                    <Col xs={6} className="text-left" style={{ color: "blue" }}>
                      {moment(new Date()).format("DD-MMM-YY")}
                    </Col>
                  </Row>
                </Col>

                {/* Right Column */}
                <Col md={6}>
                  <Row className="mb-2">
                    <Col
                      xs={6}
                      className="text-end"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Scheme:
                    </Col>
                    <Col xs={6} className="text-left" style={{ color: "blue" }}>
                      {this.props.Report?.scheme_name || "-"}
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col
                      xs={6}
                      className="text-end"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Cycle:
                    </Col>
                    <Col xs={6} className="text-left" style={{ color: "blue" }}>
                      {this.props.Report?.cycle_no || "-"}
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col
                      xs={6}
                      className="text-end"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Round:
                    </Col>
                    <Col xs={6} className="text-left" style={{ color: "blue" }}>
                      {rounds ? rounds : "N/A"}
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col
                      xs={6}
                      className="text-end"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Sample:
                    </Col>
                    <Col xs={6} className="text-left" style={{ color: "blue" }}>
                      {this.props.sample}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Row>
          </div>
          <div className="page-contant">
            <Container fluid>
              <Row className="justify-content-center align-item-center">
                <Col lg="10">
                  <Card>
                    <CardBody>
                      <div className="table-responsive">
                        {showClotMatchedNotice ? (
                          <BootstrapTable
                            keyField="id"
                            data={[
                              {
                                id: 1,
                                message:
                                  "Pre-Analytic challenge detected Successfully",
                              },
                            ]}
                            columns={[
                              {
                                dataField: "message",
                                text: "",
                                headerClasses: "text-center",
                                classes: "text-center",
                                formatter: (cell) => (
                                  <div className="d-flex justify-content-center">
                                    <strong style={{ color: "#6C48C5" }}>
                                      {cell}
                                    </strong>
                                  </div>
                                ),
                              },
                            ]}
                            bordered
                            hover
                            striped
                            wrapperClasses="table-responsive"
                            noDataIndication="No Data"
                          />
                        ) : (
                          <BootstrapTable
                            keyField="id"
                            data={
                              combinedData?.length
                                ? combinedData
                                : Report?.participants_results || []
                            }
                            columns={this.state.columnsList}
                            bordered
                            hover
                            striped
                            wrapperClasses="table-responsive"
                            noDataIndication={() => {
                              const onlySampleConditionMsg =
                                Report?.participants_results?.find(
                                  (r) => r.message,
                                );
                              return onlySampleConditionMsg
                                ? onlySampleConditionMsg.message
                                : "No Data";
                            }}
                          />
                        )}
                      </div>
                      {/* Add the note below the table */}
                      {/* Only show scoring lines if NOT showing the Pre-Analytic challenge notice */}
                      {!showClotMatchedNotice && (
                        <div className="mt-3" style={{ color: "#6C48C5" }}>
                          You have submitted results for{" "}
                          <strong>{submittedResultsCount}</strong> analytes out
                          of total <strong>{totalAnalytes}</strong> analytes.
                          <div>
                            Your TOTAL SCORE is <strong>{totalScore}</strong>{" "}
                            out of a possible score of{" "}
                            <strong>{possibleScore}</strong>
                          </div>
                          <div>
                            Your accuracy is{" "}
                            <strong>{accuracy.toFixed(2)}%</strong>
                          </div>
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </Container>
      </React.Fragment>
    );
  }
}

Results.propTypes = {
  match: PropTypes.object,
  className: PropTypes.any,

  SchemeAnalytesList: PropTypes.array,
  Report: PropTypes.array,
  SerologyResult: PropTypes.array,

  rounds: PropTypes.number,
  round_id: PropTypes.number,
  sample: PropTypes.string,
  issue_date: PropTypes.string,
  closing_date: PropTypes.string,
  onGetSchemeAnalyte: PropTypes.func,
  onGetReport: PropTypes.func,
  onGetSereologyResult: PropTypes.func,
};

const mapStateToProps = ({ SchemeAnalytesList, ResultSubmit }) => ({
  SchemeAnalytesList: SchemeAnalytesList.SchemeAnalytesList,
  rounds: SchemeAnalytesList.rounds,
  sample: ResultSubmit.Report?.sample || "",
  round_id: SchemeAnalytesList.round_id,
  issue_date: SchemeAnalytesList.issue_date,
  closing_date: SchemeAnalytesList.closing_date,
  Report: ResultSubmit.Report,
  SerologyResult: ResultSubmit.SerologyResult,
});

const mapDispatchToProps = (dispatch) => ({
  onGetSchemeAnalyte: (id) => dispatch(getSchemeAnalytesList(id)),
  onGetReport: (roundId, labId) => dispatch(getReport(roundId, labId)),
  onGetSereologyResult: (id) => dispatch(getSereologyResult(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Results));
